/**
 * Scrolltrigger Animations Desktop + Mobile
 */
export function initScrolltriggerAnimations() {
  if ($(".card_item.con-video").length) {
    document.querySelectorAll(".card_item.con-video").forEach((card) => {
      const video = card.querySelector("video");
      if (!video) return;
      video.pause();
      video.currentTime = 0;
      card.addEventListener("mouseenter", () => {
        video.play();
      });
      card.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  // =================================================

  const mm = gsap.matchMedia();

  mm.add("(min-width: 768px)", () => {
    // =================================================
    // HERO DESKTOP
    // =================================================

    if ($(".hero-home:not(#habitacion.hero-home)").length) {
      const hero = document.querySelector(".hero-home");
      const night = document.querySelector(".hero-home__background--night");
      const content = document.querySelector(".hero-home__content");

      if (!hero || !night) return;

      // NOCHE → DÍA
      gsap.to(night, {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          trigger: hero,
          start: "top top-=400px",
          end: "+=25%",
          scrub: true,
        },
      });

      // MOVIMIENTO FOTO
      gsap.to(".hero-home__background", {
        yPercent: 8,
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: hero,
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });

      // CONTENIDO
      if (content) {
        gsap.to(content, {
          y: -80,
          opacity: 0,
          ease: "none",
          scrollTrigger: {
            trigger: hero,
            start: "top top",
            end: "45% top",
            scrub: true,
          },
        });
      }
    }

    // =================================================
    // HABITACIONES DESKTOP
    // =================================================

    if ($(".hero-home").length && $("#habitaciones").length) {
      const hero = document.querySelector(".hero-home");
      const habitaciones = document.querySelector("#habitaciones");
      const mask = document.querySelector(".habitaciones__mask");

      if (hero && habitaciones && mask) {
        ScrollTrigger.create({
          trigger: hero,
          start: "bottom bottom",
          endTrigger: habitaciones,
          end: "top top",
          pin: true,
          pinSpacing: false,
        });

        gsap.fromTo(
          mask,
          {
            borderRadius: "150rem 150rem 0 0",
            scaleX: 1.05,
          },
          {
            borderRadius: "0 0 0 0",
            scaleX: 1,
            ease: "none",
            scrollTrigger: {
              trigger: habitaciones,
              start: "top 70%",
              end: "top 0%",
              scrub: true,
            },
          },
        );
      }
    }
  });

  mm.add("(max-width: 767px)", () => {
    // =================================================
    // HERO MOBILE
    // =================================================

    if ($(".hero-home:not(#habitacion.hero-home)").length) {
      const hero = document.querySelector(".hero-home");
      const night = document.querySelector(".hero-home__background--night");
      const content = document.querySelector(".hero-home__content");

      if (!hero || !night) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: hero,
          start: "top top-=60px",
          toggleActions: "play none none reverse",
        },
      });

      // Fade noche → día
      tl.to(
        night,
        {
          opacity: 0,
          duration: 0.9,
          ease: "power2.out",
        },
        0,
      );

      // Contenido desaparece
      if (content) {
        tl.to(
          content,
          {
            y: -30,
            opacity: 0,
            duration: 0.7,
            ease: "power2.out",
          },
          0,
        );
      }
    }

    // =================================================
    // HABITACIONES MOBILE
    // =================================================

    if ($("#habitaciones").length) {
      const habitaciones = document.querySelector("#habitaciones");
      const mask = document.querySelector(".habitaciones__mask");

      if (habitaciones && mask) {
        gsap.fromTo(
          mask,
          {
            borderRadius: "30rem 30rem 0 0",
            scaleX: 1.03,
          },
          {
            borderRadius: "0 0 0 0",
            scaleX: 1,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: habitaciones,
              start: "top 88%",
              toggleActions: "play none none reverse",
            },
          },
        );
      }
    }
  });

  if ($("#hotel-story").length) {
    const hotelStory = document.querySelector("#hotel-story");

    if (hotelStory && window.innerWidth > 767) {
      const track = hotelStory.querySelector(".hotel-story__track");
      const intro = hotelStory.querySelector(".hotel-story__intro");
      const outro = hotelStory.querySelector(".hotel-story__outro");

      let tl;

      function buildHotelStoryTimeline() {
        if (tl) {
          tl.scrollTrigger && tl.scrollTrigger.kill();
          tl.kill();
        }

        const vw = window.innerWidth;
        const images = track.querySelectorAll(".hotel-story__image");
        const lastImage = images[images.length - 1];
        const lastImageWidth = lastImage ? lastImage.offsetWidth : 0;

        gsap.set(track, {
          x: vw,
        });
        gsap.set(outro, {
          autoAlpha: 0,
        });
        gsap.set(intro, {
          opacity: 1,
        });

        const trackWidth = track.scrollWidth;

        // --- presupuestos en px ---
        const PAUSE_BEFORE = vw * 0.12;
        const INTRO_FADE = vw * 0.25;
        const SLIDE_IN = vw;
        const MAIN_SCROLL = trackWidth + vw; // el track igual puede recorrer esto, no importa que quede "cortado"
        const OUTRO_FADE = vw * 0.1;
        const PAUSE_AFTER = vw * 0;

        const overlap = INTRO_FADE * 3;

        // tiempo exacto (en las mismas unidades = px) en que el track termina de entrar
        // y arranca el scroll principal (coincide con el label 'scrollStart')
        const scrollStartTime = PAUSE_BEFORE + INTRO_FADE - overlap + SLIDE_IN;

        // punto en que la última imagen queda centrada
        const centerOffset = trackWidth - vw / 2 - lastImageWidth / 2;

        // 👉 el total ya NO usa MAIN_SCROLL completo ni PAUSE_AFTER largo,
        // corta justo cuando el outro termina de aparecer
        const total = scrollStartTime + centerOffset + OUTRO_FADE + PAUSE_AFTER;

        tl = gsap.timeline({
          scrollTrigger: {
            trigger: hotelStory,
            start: "top top",
            end: () => `+=${total}`,
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
            anticipatePin: 0,
            refreshPriority: 1,
          },
        });

        tl.to(
          {},
          {
            duration: PAUSE_BEFORE,
          },
        );
        tl.to(intro, {
          opacity: 0,
          duration: INTRO_FADE,
        });
        tl.to(
          track,
          {
            x: 0,
            duration: SLIDE_IN,
            ease: "none",
          },
          `-=${overlap}`,
        );

        tl.addLabel("scrollStart");
        tl.to(track, {
          x: -MAIN_SCROLL,
          duration: MAIN_SCROLL,
          ease: "none",
        });

        tl.to(
          outro,
          {
            autoAlpha: 1,
            duration: OUTRO_FADE,
          },
          `scrollStart+=${centerOffset}`,
        );

        tl.to(
          {},
          {
            duration: PAUSE_AFTER,
          },
        );
      }

      buildHotelStoryTimeline();

      window.addEventListener("load", () => ScrollTrigger.refresh());
      ScrollTrigger.addEventListener("refreshInit", buildHotelStoryTimeline);
    }
  }

  // Disable GSAP on Mobile
  // Source: https://greensock.com/forums/topic/26325-disabling-scrolltrigger-on-mobile-with-mediamatch/
  ScrollTrigger.matchMedia({
    // Desktop Only Scrolltrigger
    "(min-width: 721px)": function () {
      //const preloadImages = (selector = 'img') => {
      // return new Promise((resolve) => {
      //    imagesLoaded(document.querySelectorAll(selector), {background: true}, resolve);
      //});
      //};
      if ($(".caption").length) {
        // Function to trigger Flip animations when scrolling
        const triggerFlipOnScroll = (galleryEl, options) => {
          let settings = {
            flip: {
              absoluteOnLeave: false,
              absolute: false,
              scale: true,
              simple: true,
            },
            scrollTrigger: {
              start: "top top",
              end: "+=350%",
            },
            stagger: 0,
          };

          settings = Object.assign({}, settings, options);

          const galleryCaption = galleryEl.querySelector(".caption");
          const galleryBg = galleryEl.querySelector(".gallery__item .bg");
          const galleryItems = galleryEl.querySelectorAll(".gallery__item");
          const galleryItemsInner = [...galleryItems]
            .map((item) => (item.children.length > 0 ? [...item.children] : []))
            .flat();

          // --- Preparar SplitText para el caption ---
          let splitLines = null;
          let moonSeparator = null;
          let textEls = [];

          if (galleryCaption) {
            moonSeparator = galleryCaption.querySelector(".moon_separator");

            textEls = [
              ...galleryCaption.querySelectorAll(
                ".section-label, .uppercase, h2, h4, p, .boton",
              ),
            ].filter(
              (el) => el.textContent.trim() && !el.closest(".moon_separator"),
            );

            if (textEls.length) {
              splitLines = new SplitText(textEls, {
                type: "lines",
              });
              new SplitText(textEls, {
                type: "lines",
                linesClass: "lineParent",
              });

              gsap.set(
                textEls
                  .map((el) => [...el.querySelectorAll(".lineParent")])
                  .flat(),
                {
                  overflow: "hidden",
                },
              );

              gsap.set(splitLines.lines, {
                yPercent: 125,
              });
            }
          }

          if (galleryBg) {
            gsap.set(galleryBg, {
              opacity: 0,
            });
          }

          // --- FLIP ---
          galleryEl.classList.add("gallery--switch");
          const flipstate = Flip.getState([galleryItems], {
            props: "filter",
          });
          galleryEl.classList.remove("gallery--switch");

          // --- Timeline Principal ---
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: galleryEl,
              start: settings.scrollTrigger.start,
              end: settings.scrollTrigger.end,
              pin: galleryEl.parentNode,
              scrub: true,
            },
          });

          // 1. Zoom / Flip inicial (duración 1.8)
          tl.add(
            Flip.to(flipstate, {
              ease: "none",
              duration: 1.8,
              absoluteOnLeave: settings.flip.absoluteOnLeave,
              absolute: settings.flip.absolute,
              scale: settings.flip.scale,
              simple: settings.flip.simple,
              stagger: settings.stagger,
            }),
            0,
          );

          if (galleryItemsInner.length) {
            tl.fromTo(
              galleryItemsInner,
              {
                scale: 1.5,
              },
              {
                scale: 1,
                duration: 1.8,
                ease: "none",
              },
              0,
            );
          }

          // 2. FASE 2: El bg aparece hacia el final del zoom (empieza en 1.2, dura 0.5s → termina en 1.7s)
          if (galleryBg) {
            tl.to(
              galleryBg,
              {
                opacity: 1,
                duration: 0.5,
                ease: "none",
              },
              1.2,
            );
          }

          // 3. FASE 3: El caption y sus elementos
          if (galleryCaption) {
            // PASO A: Suben las líneas de texto JUSTO CUANDO TERMINA EL BG (">")
            if (splitLines && splitLines.lines.length) {
              tl.to(
                splitLines.lines,
                {
                  yPercent: 0,
                  duration: 0.8,
                  stagger: 0.08,
                  ease: "power2.out",
                },
                ">",
              ); // 👈 Arrastra secuencialmente al terminar galleryBg
            }

            // PASO B: Animación del moon_separator JUSTO CUANDO TERMINA EL TEXTO (">")
            if (moonSeparator) {
              const lineLeft = moonSeparator.querySelector("span:first-child");
              const lineRight = moonSeparator.querySelector("span:last-child");
              const moon = moonSeparator.querySelector(".moon_separator_moon");

              if (lineLeft) {
                tl.fromTo(
                  lineLeft,
                  {
                    scaleX: 0,
                    transformOrigin: "right center",
                  },
                  {
                    scaleX: 1,
                    duration: 0.85,
                    ease: "expo.out",
                  },
                  ">", // 👈 Espera a que termine la animación del texto
                );
              }

              if (lineRight) {
                tl.fromTo(
                  lineRight,
                  {
                    scaleX: 0,
                    transformOrigin: "left center",
                  },
                  {
                    scaleX: 1,
                    duration: 0.85,
                    ease: "expo.out",
                  },
                  "<", // Se ejecuta en paralelo con lineLeft
                );
              }

              if (moon) {
                tl.fromTo(
                  moon,
                  {
                    scale: 0,
                    rotate: "100deg",
                    opacity: 0,
                  },
                  {
                    scale: 1,
                    rotate: "0deg",
                    opacity: 1,
                    duration: 0.65,
                    ease: "expo.out",
                  },
                  "<0.1",
                );
              }
            }
          }

          return tl;
        };

        // --- SEPARADOR LUNA (Encadenamiento correcto con :not para evitar ejecuciones dobles) ---
        const initMoonSeparator = () => {
          const separators = document.querySelectorAll(
            ".moon_separator:not(.hero-home .moon_separator):not(.caption .moon_separator):not(#quienes-intro .moon_separator)",
          );

          separators.forEach((separator) => {
            const lineLeft = separator.querySelector("span:first-child");
            const lineRight = separator.querySelector("span:last-child");
            const moon = separator.querySelector(".moon_separator_moon");

            const moonTl = gsap.timeline({
              scrollTrigger: {
                trigger: separator,
                start: "top 70%",
                toggleActions: "play none none none",
              },
            });

            if (lineLeft && lineRight) {
              moonTl.fromTo(
                [lineLeft, lineRight],
                {
                  scaleX: 0,
                },
                {
                  duration: 0.85,
                  scaleX: 1,
                  stagger: 0.04,
                  ease: "expo.out",
                },
                0,
              );
            }

            if (moon) {
              moonTl.fromTo(
                moon,
                {
                  scale: 0,
                  rotate: "100deg",
                  opacity: 0,
                },
                {
                  duration: 0.65,
                  scale: 1,
                  rotate: "0deg",
                  opacity: 1,
                  ease: "expo.out",
                },
                0.2,
              );
            }
          });
        };

        const scroll = () => {
          const galleries = [
            {
              id: "#gallery-8",
              options: {
                flip: {
                  scale: false,
                },
              },
            },
          ];

          galleries.forEach((gallery) => {
            const galleryElement = document.querySelector(gallery.id);
            if (galleryElement) {
              triggerFlipOnScroll(galleryElement, gallery.options);
            }
          });

          initMoonSeparator();
        };

        document.fonts.ready.then(() => {
          setTimeout(() => {
            scroll();
            ScrollTrigger.refresh();
          }, 100);
        });
      }
      //CARTA
      if (document.querySelector("#carta")) {
        gsap.registerPlugin(ScrollTrigger);
        const carta = document.querySelector("#carta");
        const filtros = document.querySelector("#carta .filtros-container");
        ScrollTrigger.create({
          trigger: filtros,
          start: "top 130px",
          endTrigger: carta,
          end: "bottom bottom",
          pin: filtros,
          pinSpacing: false,
          invalidateOnRefresh: true,
        });
      }
      //GALERIA

      //GALERIA
      if (document.querySelector("#galeria")) {
        gsap.registerPlugin(ScrollTrigger);
        const filtros = document.querySelector("#galeria .filtros-container");
        const mosaico = document.querySelector("#galeria .mosaico-container");
        const pinST = ScrollTrigger.create({
          trigger: filtros,
          start: "top 130px",
          pin: filtros,
          pinSpacing: false,
          end: () => "+=" + (mosaico.offsetHeight - filtros.offsetHeight),
          invalidateOnRefresh: true,
        });
        const imgs = document.querySelectorAll("#galeria .mosaico-item img");
        let loaded = 0;
        imgs.forEach((img) => {
          if (img.complete) loaded++;
          else
            img.addEventListener("load", () => {
              loaded++;
              if (loaded === imgs.length) ScrollTrigger.refresh();
            });
        });
        if (loaded === imgs.length) ScrollTrigger.refresh();
      }
    }, // End Desktop Only Scrolltrigger
    // Mobile Only Scrolltrigger
    "(max-width: 720px)": function () {}, // End Mobile Only Scrolltrigger
    // 4k Only Scrolltrigger
    "(min-width: 2560px)": function () {}, // End Mobile Only Scrolltrigger
  }); // End GSAP Matchmedia

  if ($(".anim-container").length) {
    gsap.utils.toArray(".anim-container").forEach((container) => {
      // 1. Buscamos y validamos los elementos estándar (.anim-item) EN ESTE contenedor
      const animItems = container.querySelectorAll(".anim-item");
      if (animItems.length > 0) {
        gsap.from(animItems, {
          y: 120,
          duration: 1.25,
          opacity: 0,
          scrollTrigger: {
            trigger: container,
            start: "top 45%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
          },
          ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.75,
          },
        });
      }
      const animItemsLinea = container.querySelectorAll(".linea-titulo");
      if (animItemsLinea.length > 0) {
        gsap.from(animItemsLinea, {
          width: "0%",
          duration: 1,
          scrollTrigger: {
            trigger: container,
            start: "top 45%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
            //markers: true
          },
          // ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.75,
          },
        });
      }
      // 2. Buscamos y validamos los elementos no-scroll (.anim-item-ns) EN ESTE contenedor
      const animItemsNs = container.querySelectorAll(".anim-item-ns");
      if (animItemsNs.length > 0) {
        gsap.from(animItemsNs, {
          y: 120,
          duration: 1.25,
          opacity: 0,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
          },
          ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.75,
          },
        });
      }
      const animItemsLineaNs = container.querySelectorAll(".linea-titulo.foo");
      if (animItemsLineaNs.length > 0) {
        gsap.from(animItemsLineaNs, {
          width: "0%",
          duration: 1,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
            //  markers:true
          },
          //ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.75,
          },
        });
      }
    });
  }

  if ($(".split-line").length) {
    const splitPArray = gsap.utils.toArray(".split-line");
    document.fonts.ready.then(function () {
      splitPArray.forEach((P) => {
        const splitP = new SplitText(P, {
          type: ["lines"],
        });
        const splitPParent = new SplitText(P, {
          type: ["lines"],
          linesClass: "lineParent",
        });
        gsap.set(".lineParent", {
          overflow: "hidden",
        });
        const hasFooClass = P.classList.contains("foo");
        gsap.from(splitP.lines, {
          yPercent: 125,
          stagger: 0.1,
          scrollTrigger: {
            trigger: splitP.lines,
            start: hasFooClass ? "top 99%" : "top 80%",
          },
        });
      });
    });
  }
  if ($(".split-line-container").length) {
    const splitPArray = gsap.utils.toArray(
      ".split-line-container p, .split-line-container h1, .split-line-container h2, .split-line-container h3, .split-line-container h4,   .split-line-container ul li",
    );

    document.fonts.ready.then(() => {
      setTimeout(() => {
        const isMobile = window.innerWidth < 1024; // Ajusta el breakpoint si lo necesitas

        splitPArray.forEach((P) => {
          if (!P.textContent.trim()) return;

          // En mobile, reemplazamos los <br> por un espacio para que SplitText los ignore
          if (isMobile) {
            P.querySelectorAll("br").forEach((br) => {
              br.replaceWith(" ");
            });
          }

          const splitP = new SplitText(P, {
            type: "lines",
          });
          const splitPParent = new SplitText(P, {
            type: "lines",
            linesClass: "lineParent",
          });

          gsap.set(P.querySelectorAll(".lineParent"), {
            overflow: "hidden",
          });

          const hasFooClass = P.closest(
            ".split-line-container",
          ).classList.contains("foo");

          gsap.from(splitP.lines, {
            yPercent: 125,
            stagger: 0.1,
            scrollTrigger: {
              trigger: P,
              start: hasFooClass ? "top 99%" : "top 80%",
            },
          });
        });
      }, 50);
    });
  }

  //SEPARADOR LUNA
  document.querySelectorAll(".moon_separator").forEach((separator) => {
    const extraSeparators = document.querySelectorAll(
      ".moon_separator:not(.hero-home .moon_separator):not(.caption .moon_separator):not(#quienes-intro .moon_separator)",
    );

    extraSeparators.forEach((separator) => {
      const lineLeft = separator.querySelector("span:first-child");
      const lineRight = separator.querySelector("span:last-child");
      const moon = separator.querySelector(".moon_separator_moon");

      if (lineLeft && lineRight) {
        gsap.set([lineLeft, lineRight], {
          scaleX: 0,
        });
      }

      if (moon) {
        gsap.set(moon, {
          scale: 0,
          rotate: "100deg",
          opacity: 0,
        });
      }

      const isFooter = separator.closest("#contacto");

      const moonTl = gsap.timeline({
        scrollTrigger: {
          trigger: separator,
          start: isFooter ? "top 90%" : "top 70%",
          toggleActions: "play none none none",
          //markers: true,
        },
      });

      if (lineLeft && lineRight) {
        moonTl.to(
          [lineLeft, lineRight],
          {
            duration: 0.85,
            scaleX: 1,
            stagger: 0.04,
            ease: "expo.out",
          },
          0,
        );
      }

      if (moon) {
        moonTl.to(
          moon,
          {
            duration: 0.65,
            scale: 1,
            rotate: "0deg",
            opacity: 1,
            ease: "expo.out",
            delay: 0.2,
          },
          0,
        );
      }
    });
  });

  /*if ($(".marquee").length) {
    const marquee = document.querySelector(".marquee");
    const spans = marquee.querySelectorAll(".marquee > span");
    const videos = marquee.querySelectorAll(".marquee > span video");
    let loop = gsap.to(spans, {
      xPercent: -100,
      repeat: -1,
      duration: 24,
      ease: "none",
      force3D: true,
      overwrite: true,
      rotationZ: 0.01,
    });
    ScrollTrigger.create({
      trigger: marquee,
      start: "top bottom",
      end: "bottom top",
      onEnter: () => {
        loop.play();
        videos.forEach((v) => v.play());
      },
      onLeave: () => {
        loop.pause();
        videos.forEach((v) => v.pause());
      },
      onEnterBack: () => {
        loop.play();
        videos.forEach((v) => v.play());
      },
      onLeaveBack: () => {
        loop.pause();
        videos.forEach((v) => v.pause());
      },
    });
  }*/
  ///////////////////
  // Images parallax
  /**/
  if ($(".img-p-container").length) {
    gsap.utils.toArray(".img-p-container").forEach((container) => {
      const img = container.querySelector("img");
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
        },
      });
      tl.fromTo(
        img,
        {
          yPercent: -7,
          ease: "none",
        },
        {
          yPercent: 7,
          ease: "none",
        },
      );
    });
  }
  //////////////////
  if ($(".reveal-img").length) {
    let revealContainers = document.querySelectorAll(".reveal-img");
    revealContainers.forEach((container) => {
      let image = container.querySelector("img");
      let t1 = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          // markers:true,
          start: "top 175%",
          end: "100% 0%",
        },
      });
      t1.set(container, {
        autoAlpha: 1,
      });
      t1.from(container, 1, {
        yPercent: 100,
        ease: Power2.out,
      });
      t1.from(image, 1, {
        yPercent: 0,
        scale: 1.2,
        delay: -1,
        ease: Power2.out,
      });
    });
  }
  ///////////////////////////////
  if ($(".reveal").length) {
    let revealLi = gsap.utils.toArray(".reveal");
    revealLi.forEach((wrapreveal) => {
      const image = wrapreveal.querySelector(".reveal>div,.reveal>a"),
        tl = gsap.timeline({
          paused: true,
        });
      tl.set(image, {
        autoAlpha: 1,
      });
      tl.from(wrapreveal, 1, {
        yPercent: 0,
        ease: "power2",
        clearProps: true,
      });
      tl.from(image, 1, {
        yPercent: 300,
        scale: 1.3,
        delay: -1,
        ease: "power2",
        //clearProps: true
      });
      wrapreveal.animation = tl; // record it on each element so we can reference the timeline later
    });
    ScrollTrigger.batch(revealLi, {
      onEnter: (elements) =>
        elements.forEach((e, i) => e.animation.delay(i * 0.1).restart(true)),
      once: true,
    });
  }
  /////////////////////////////
  if ($(".cloud-layer").length) {
    document.querySelectorAll(".cloud-layer").forEach((layer, index) => {
      const isMobile = window.innerWidth <= 540;
      const track = layer.querySelector(".cloud-track");
      const list = layer.querySelector(".cloud-list");

      const width = list.offsetWidth;

      const speeds = isMobile ? [30, 50, 70] : [90, 120, 150];

      const reverse = index === 1;

      gsap.fromTo(
        track,
        {
          x: reverse ? -width : 0,
        },
        {
          x: reverse ? 0 : -width,
          duration: speeds[index],
          ease: "none",
          repeat: -1,
        },
      );
    });
  }
}
